import React 				from 'react'
import { Provider } 		from 'react-redux'

import {
	configureStore
} from './src/redux'

import {
	linkSameMinusHash
} from './src/lib/formatLink'
import {
	scrollToID,
	scrollToY
} from './src/lib/scrollTo'

export const wrapRootElement = ({ element }) => {
	const store = configureStore()
	
	return <Provider store={ store }>
		{ element }
	</Provider>
}

const transitionDelay = 600

let previousPath = window ? window.location.href : null

export const shouldUpdateScroll = ({
	routerProps: { location },
	getSavedScrollPosition,
}) => {
	if(location.action === 'PUSH') {
		if(previousPath && linkSameMinusHash(previousPath, location.href)){
			scrollTo(location, 1200)
		} else {
			window.setTimeout(() => {
				scrollTo(location, 0)
			}, transitionDelay)
		}
	} else {
		const savedPosition = getSavedScrollPosition(location)
		window.setTimeout(
			() => window.scrollTo(...(savedPosition || [0, 0])),
			transitionDelay
		)
	}
	previousPath = location.href
	return false
}

const scrollTo = (location, time = 900) => {
	const hash = location.hash ? location.hash.replace('#', '') : null
	if(hash){
		scrollToID(hash, time)
	} else {
		scrollToY(0, time)
	}
}